var Actions;
(function (Actions) {
    Actions["GET_WBS_LIST"] = "getWBSList";
    Actions["GET_WBS_LIST_ALLDATA"] = "getWBSListAllData";
    Actions["UPDATE_WBS_PAGE_FILTER"] = "updateWBSPageFilter";
    Actions["UPDATE_WBS_SIZE"] = "updateWBSSize";
    Actions["UPDATE_WBS_DESC"] = "updateWBSDesc";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    // asset number for module mapping profilling, budget catalog
    Mutations["SET_WBS_LOAD"] = "setWBSWasFirstLoad";
    Mutations["SET_WBS_LIST"] = "setWBSList";
    Mutations["SET_WBS_HANDLE_PAGE"] = "setWBSHandlePage";
    Mutations["SET_WBS_PAGE"] = "setWBSPage";
    Mutations["SET_WBS_LOAD_PAGE"] = "setWBSLoadPage";
    Mutations["SET_WBS_LOADING"] = "setWBSLoading";
    Mutations["SET_WBS_STATUS"] = "setWBSStatus";
    Mutations["SET_SELECTED_WBS"] = "setSelectedWBS";
    Mutations["SET_DROPDOWNLIST_WBSELEMENT2"] = "setDropdownlistWBSElement2";
    Mutations["SET_WBS_SIZE"] = "setWbsSize";
    Mutations["SET_WBS_HANDLE_SIZE"] = "setWbsHandleSize";
    Mutations["SET_WBS_PAGE_FILTER"] = "setWBSPageFilter";
    Mutations["SET_WBS_WAS_LOAD_QUICK_FILTER"] = "setWBSWasLoadQuickFilter";
    Mutations["SET_WBS_DESC"] = "setWBSSelectedDesc";
    Mutations["SET_WBS_SEARCH_BY"] = "setWBSSelectedSearchBy";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
